import { Column } from 'devextreme-react/data-grid';
import React, { useEffect, useState } from 'react';
import { formatMessage } from 'devextreme/localization';
import { Button } from 'devextreme-react/button';
import columnDataGrid from './columnDataGrid';
import DataGridMVP from '../../DataGridMVP';
import PopupMVP from '../../PopupMVP';
import useWasteColumns from '../../../hooks/useWasteColumns';

const normalizeRollsForTable = (rolls) => rolls.map((el) => ({
  pieceNumId: el.pieceNumId,
  batchId: el.batchId,
  cgId: el.cgId,
  actualPieceId: el.actualPieceId,
  weight: el.weightNetto,
  weightRemain: el.weightRemain,
  // eslint-disable-next-line no-restricted-globals
  percentWasteMaterial: isNaN(el.percentWasteMaterial) ? 0 : el.percentWasteMaterial,
  weightCurrent: el.weightCurrent || 0,
  weightOff: 0,
  qcId: el.qcId || 0,
  quantity: el.quantity || 0,
  quantityRemain: el.quantityRemain || 0,
  quantityOff: 0,
  quantityCurrent: el.quantityCurrent || 0,
  unit: el.unit,
  unitShortName: el.unitShortName || el.unitShort, // NOTE: заменить/убрать при унификации модели
  unitShort: el.unitShort,
  weightWasteMaterialCurrent: el.weightWasteMaterialCurrent || 0,
  allWastes: el.allWastes,
  allSapSemiWastes: el.allSapSemiWastes
}));

const AddSemiForCorrection = ({
  tabsReducer: { tabSelect },
  inputReadyProductReducer: { taskNumId, operationNumId },
  correctionSemiProductsReducer: { correctionSemi, loading },
  getCorrectionSemi,
  plantId,
  addInputPiece,
  visible,
  setVisible
}) => {
  const [selectedData, setSelectedData] = useState([]);
  const [withWasteData, wasteColumns] = useWasteColumns(normalizeRollsForTable(correctionSemi));

  useEffect(() => {
    if (taskNumId && plantId && tabSelect === 8) {
      getCorrectionSemi({ taskId: taskNumId, operationNumId, plantId });
    }
  }, [getCorrectionSemi, operationNumId, plantId, tabSelect, taskNumId]);
  const onClickCancelSemi = () => { setVisible(false); };

  const onSaveSemi = () => {
    addInputPiece(selectedData);
    setVisible(false);
  };

  return (
    <PopupMVP
    visible={visible}
    onHiding={onClickCancelSemi}
    title={'Добавить ПФ'}
    width={'85%'}
    height={'auto'}
  >
      <div className="formData">
        <div>
          <DataGridMVP
         className="shipment"
         setStateStoringName={'dataGridGetSemiProducts'}
         keyExpr="pieceNumId"
         visibleButtonDateRangePicker={false}
         visibleSummary={false}
         onSelectionChanged={(value) => { setSelectedData(value.selectedRowsData); }}
         visibleGroupPanel={false}
         visibleInfoIcon={false}
         visibleSearchPanel={false}
         selectionMode="multiple"
         tText={formatMessage('textPeriod')}
         dataSource={withWasteData}
         loadingData={loading}
         filterDataGrid
          >
            {columnDataGrid.map((item) => (
              <Column
                dataField={item.dataField}
                caption={item.caption}
                visible={!item.notVisible}
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
              />
            ))}
            {wasteColumns}
          </DataGridMVP>
        </div>
        <div className="formButton">
          <Button
          type="default"
          stylingMode="contained"
          onClick={onSaveSemi}
          width={260}
          text={formatMessage('textButton').save}
        />
          <Button
          type="default"
          stylingMode="contained"
          onClick={onClickCancelSemi}
          width={260}
          text={formatMessage('textButton').cancel}
        />
        </div>
      </div>
    </PopupMVP>
  );
};

export default React.memo(AddSemiForCorrection);
